import Input from './input';
export { default as PasswordInput } from './password-input';
export default Input;
